// extracted by css-extract-rspack-plugin
export default {"tabs":"aocEQCAuMnghnTLM","tabList":"ZkhCiefRKaYtfxHF","tab":"D7DLB7SYUAgRdiih","tabPanel":"OweIoceWfUb2K3u2"};